import { Enum } from './Enum';

export class LeagueEnum extends Enum {
    static Gold = "gold";
    static Silver = "silver";
    static Bronze = "bronze";
    static Iron = "iron";

    static items = [
        {
            id: LeagueEnum.Gold,
            name: 'Участник золотой лиги',
            color: "#E1982B",
            iconOne: "LEAGUE_GOLD_ONE",
            iconAnother: "LEAGUE_GOLD_ANOTHER"
        },
        {
            id: LeagueEnum.Silver,
            name: 'Участник серебрянной лиги',
            color: "#ECEDEE",
            iconOne: "LEAGUE_SILVER_ONE",
            iconAnother: "LEAGUE_SILVER_ANOTHER"
        },
        {
            id: LeagueEnum.Bronze,
            name: 'Участник бронзовой лиги',
            color: "#FBE5C1",
            iconOne: "LEAGUE_BRONZE_ONE",
            iconAnother: "LEAGUE_BRONZE_ANOTHER"
        },
        {
            id: LeagueEnum.Iron,
            name: 'Участник железной лиги',
            color: "#FFFFFF",
            iconOne: "LEAGUE_IRON",
            iconAnother: "LEAGUE_IRON"
        },
    ];
}

